/**
 * Class used to store keys/tokens in the browser storage
 */
import { ZYW_FEATURE_AGENCIES, ZYW_LEADS_LOGIN_RETRY_COUNT } from 'lib/config/appConstants';

class AppStore {
  /**
   * Returns the token, undefined if None
   */
  static fetchToken() {
    if (typeof Storage !== 'undefined') {
      // Code for localStorage/sessionStorage.
      var key = localStorage.getItem('token');
      if (key !== null && key !== undefined) {
        return key;
      }
    }
  }

  /**
   * Stores the token in storage
   * @param token
   */
  static storeToken(token) {
    if (typeof Storage !== 'undefined') {
      // Code for localStorage/sessionStorage.
      localStorage.setItem('token', token);
    }
  }

  /**
   * Deletes the token from storage
   * @param token
   */
  static deleteToken() {
    if (typeof Storage !== 'undefined') {
      // Code for localStorage/sessionStorage.
      localStorage.removeItem('token');
    }
  }

  /**
   * Returns the user info, undefined if None
   */
  static fetchUserInfo() {
    if (typeof Storage !== 'undefined') {
      // Code for localStorage/sessionStorage.

      try {
        var uinfo = localStorage.getItem('user.info');

        if (uinfo !== null) {
          return JSON.parse(uinfo);
        }
      } catch {
        // return null if there is any error
        return null;
      }
    }
    return null;
  }

  /**
   * Stores the user info in storage
   * @param userInfo
   */
  static storeUserInfo(userInfo) {
    if (typeof Storage !== 'undefined') {
      // Code for localStorage/sessionStorage.
      localStorage.setItem('user.info', JSON.stringify(userInfo));
      // delete the login retry counter
      localStorage.removeItem(ZYW_LEADS_LOGIN_RETRY_COUNT);
    }
  }

  /**
   * Deletes the user info from storage
   */
  static deleteUserInfo() {
    if (typeof Storage !== 'undefined') {
      // Code for localStorage/sessionStorage.
      localStorage.removeItem('user.info');
    }
  }

  /**
   * Returns the zywave user feature license and agencies, undefined if None
   */
  static fetchZywaveUserFeatureAgencies() {
    if (typeof Storage !== 'undefined') {
      // Code for localStorage/sessionStorage.
      var agencies = localStorage.getItem(ZYW_FEATURE_AGENCIES);
      if (agencies !== null && agencies !== undefined) {
        return JSON.parse(agencies);
      }
    }
    return null;
  }

  /**
   * Stores the Zywave's user feature license and agencies in storage
   * @param userInfo
   */
  static storeZywaveUserFeatureAgencies(userFeatureAgencies) {
    if (typeof Storage !== 'undefined') {
      // Code for localStorage/sessionStorage.
      localStorage.setItem(ZYW_FEATURE_AGENCIES, JSON.stringify(userFeatureAgencies));
    }
  }

  /**
   * Deletes the zywave user feature license and agencies from storage
   */
  static deleteZywaveUserFeatureAgencies() {
    if (typeof Storage !== 'undefined') {
      // Code for localStorage/sessionStorage.
      localStorage.removeItem(ZYW_FEATURE_AGENCIES);
    }
  }
}

export default AppStore;
